export default {
	default: [''],
	text: ['section-header--txt'],
	textDivider: ['section-header--txt-divider'],
	defaultBg1: ['section-header--bg-1'],
	defaultBg2: ['section-header--bg-2']
};
